import direction from '@/assets/icons/direction.svg'
import email from '@/assets/icons/email.svg'
import phone from '@/assets/icons/phone.svg'
import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { Card } from './Card'
import { useCompanyDetail } from '../api/getCompanyDetail'

export const ContactDetails = () => {
  const companyDetail = useCompanyDetail()
  if (companyDetail.isLoading) {
    ;<div className="flex h-96 w-full items-center justify-center">
      <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
    </div>
  }
  return (
    <section className={`${pageXPadding} ${pageYPadding}`}>
      <div
        className={`${pageMaxWidth} mx-auto flex flex-col gap-y-[16px] md:gap-x-[25px] lg:flex-row`}
      >
        <div className="flex w-full shrink-0 flex-col  gap-y-[16px] lg:w-1/4">
          <div className="flex justify-center lg:justify-start">
            <SectionTitle title="Contact Us" />
          </div>
          <div className="flex flex-col gap-y-[13px]">
            <div className="flex flex-col">
              <h2 className="text-center font-nunito text-[16px]  font-bold leading-[19.2px] text-[#000000] md:text-[24px] md:leading-[28.8px] lg:text-start lg:text-[32px] lg:leading-[38.4px]">
                Get in Touch
              </h2>
              <p className="text-center font-nunito text-[12px] leading-[19.2px] text-[#000000] md:text-[14px] md:leading-[22.4px] lg:text-start lg:text-[16px] lg:leading-[25.6px]">
                {`Have questions or ready to start your project? We're here to help! Reach out to us today, and let's bring your ideas to life.`}
              </p>
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col items-center gap-y-[13px] md:gap-x-[25px]  lg:flex-row">
          <Card
            icon={direction}
            title="Address"
            detail={companyDetail.data?.address || ''}
          />

          <Card
            icon={email}
            title="Email"
            detail={companyDetail.data?.email || ''}
          />

          <Card
            icon={phone}
            title="Call us"
            detail={companyDetail.data?.contact || ''}
          />
        </div>
      </div>
    </section>
  )
}
